if (!customElements.get('product-card-variants')) {
  class ProductCardVariants extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.card = this.closest('[data-js-product-item]');
      this.variantInput = this.card?.querySelector('[data-card-variant-id]');
      this.price = this.card?.querySelector('[data-card-variant-price]');
      this.addButton = this.card?.querySelector('[data-card-add-button]');
      this.addEventListener('change', event => {
        if (event.target.matches('[data-card-variant-choice]')) this.selectVariant(event.target);
      });
      const selected = this.querySelector('[data-card-variant-choice]:checked');
      if (selected) this.selectVariant(selected);
    }

    selectVariant(choice) {
      const option = choice.closest('[data-card-variant-option]');
      const priceTemplate = option?.querySelector('[data-card-variant-price-template]');
      if (this.variantInput) this.variantInput.value = choice.value;
      if (this.price && priceTemplate) this.price.replaceChildren(priceTemplate.content.cloneNode(true));
      if (this.addButton && option?.dataset.addLabel) this.addButton.setAttribute('aria-label', option.dataset.addLabel);
    }
  }

  customElements.define('product-card-variants', ProductCardVariants);
}
